import { render, staticRenderFns } from "./recuperarPasswordModal.vue?vue&type=template&id=50f7bec6"
import script from "./recuperarPasswordModal.vue?vue&type=script&lang=js"
export * from "./recuperarPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./recuperarPasswordModal.vue?vue&type=style&index=0&id=50f7bec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports